import React, { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import Select from "react-select";
import { components } from "react-select";
import { object } from 'yup';
// css
import styles from "./AssignStaffToTherapist.module.scss";

// img
import p1 from "../../../Assets/images/user.png";
import { useDisciplineLookupQuery } from "store/services/disciplines";
import { useGetTherapistsListQuery, useLazyGetTherapistDataQuery } from "store/services/therapistProfiles";
import { userFullName } from "helpers/common";
import { Formik } from "formik";
import { numberRequiredSchema, select2RequiredSchema } from "utils/validation/validationHelpers";
import LoadingIndicator from "components/shared/LoadingIndicator";
import LoadingButton from "components/shared/LoadingButton";
import { CloseIcon } from "Assets/icons";
import { CommonSelect, CustomAsyncSelect, RequiredFieldAstrick } from "components/Common/Common";
import * as Yup from 'yup'
import errorMessages from "utils/validation/errorMessages";

const AssignTherapistSchema = object().shape({
    caseload_id: numberRequiredSchema,
    discipline_id: select2RequiredSchema,
    therapist_id: select2RequiredSchema,
});

const AssignStaffToTherapistPop = ({ showPopup, setShowPopup, staffId = "", handleSubmit, isLoading = false }) => {
    const [selectedDiscipline, setSelectedDiscipline] = useState( null);
    const [therapistOptions, setTherapistOptions] = useState([]);

    const { data: disciplinesList, isLoading: disciplinesLoading } = useDisciplineLookupQuery();
    const { data: therapistListData, isFetching: therapistsLoading } = useGetTherapistsListQuery({ discipline: selectedDiscipline, type: "veteran", status: "active" }, { skip: !selectedDiscipline });
    const therapistList = therapistListData?.records;

    const popupLoading = disciplinesLoading;
    console.log('selectedDiscipline', selectedDiscipline)
    const disciplineOptions =
        disciplinesList?.length > 0
            ? disciplinesList?.map(discipline => ({
                value: discipline.id,
                label: discipline.name
            }))
            : [];

    useEffect(() => {
        setTherapistOptions(therapistList?.length > 0
            ? therapistList?.map(therapist => ({
                value: therapist.id,
                label: userFullName(therapist),
                email: therapist.email,
                icon: therapist.therapist_detail?.profile_picture,
            }))
            : [])
    }, [therapistList]);

    const handleDiscipline = () => setShowPopup(!showPopup);

    const validationSchema = Yup.object().shape({
        therapist_id: Yup.object({
            value: Yup.string().required(errorMessages?.required),
            // label: Yup.string().required('Label is requir    ed')
        }).required(errorMessages?.required)
    })

        return(
        <>
        <Modal
            show={showPopup}
            className={`${styles.AssignDiscipline}  AssignDiscipline`}
            onHide={handleDiscipline}
            backdrop="static"
            keyboard={false}
            centered
        >
            <Modal.Body className={`${styles.modalBody} position-relative rounded`}>
                <Button
                    onClick={handleDiscipline}
                    className="border-0 p-0 position-absolute"
                    variant="transparent"
                    style={{ right: 10, top: 0 }}
                >
                    <CloseIcon />
                </Button>
                {popupLoading ? (
                    <LoadingIndicator />
                ) : (
                    <Formik
                        initialValues={{
                            // caseload_id: caseLoadId,
                            discipline_id: null,
                            therapist_id: null,
                        }}
                        validationSchema={validationSchema}
                        onSubmit={handleSubmit}
                        enableReinitialize
                    >
                        {({
                            handleSubmit,
                            setFieldValue,
                            values,
                            errors,
                            touched
                        }) => (
                            <Form onSubmit={handleSubmit}>
                                <Row className="justify-content-center">
                                    <Col sm="10" className="my-2 col-12">
                                        <ul
                                            className={`${styles.list} list-unstyled ps-0 mb-0 position-relative`}
                                        >
                                            <li className=" py-3">
                                                <div className="d-flex align-items-start gap-10 ">
                                                    <span
                                                        className="flex-shrink-0 d-flex align-items-center justify-content-center rounded-circle themeBlue fw-bold"
                                                        style={{ height: 35, width: 35, background: "#D9D9D9" }}
                                                    >
                                                        1
                                                    </span>
                                                    <div
                                                        className="content"
                                                        style={{ width: "calc(100% - 40px)" }}
                                                    >
                                                        <h6 className="m-0 fw-sbold themeBlue pb-2 d-flex">
                                                            Discipline
                                                            <RequiredFieldAstrick />
                                                        </h6>
                                                        <CommonSelect
                                                            name="discipline_id"
                                                            placeholder="Select Discipline"
                                                            classNamePrefix={"khan"}
                                                            option={disciplineOptions}
                                                            onChange={(selected) => {
                                                                setSelectedDiscipline(selected?.value);
                                                                setFieldValue("therapist_id", null);
                                                                setTherapistOptions([])
                                                            }}
                                                            isLoading={disciplinesLoading}
                                                        />
                                                    </div>
                                                </div>
                                            </li>
                                            <li className=" py-3">
                                                <div className="d-flex align-items-start gap-10 ">
                                                    <span
                                                        className="flex-shrink-0 d-flex align-items-center justify-content-center rounded-circle themeBlue fw-bold"
                                                        style={{ height: 35, width: 35, background: "#D9D9D9" }}
                                                    >
                                                        2
                                                    </span>
                                                    <div
                                                        className="content"
                                                        style={{ width: "calc(100% - 40px)" }}
                                                    >
                                                        <h6 className="m-0 fw-sbold themeBlue pb-2 d-flex">
                                                            Assign Therapist
                                                            <RequiredFieldAstrick />
                                                        </h6>
                                                        <CommonSelect
                                                            name="therapist_id"
                                                            placeholder="Select Therapist"
                                                            option={therapistOptions}
                                                            isLoading={therapistsLoading}
                                                        // onChange={(selected) => setFieldValue("therapist_id", selected?.value)}
                                                        />
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                        <div className="btnWrpper mt-4">
                                            <LoadingButton
                                                type="submit"
                                                className="d-flex align-items-center justify-content-center commonBtn w-100"
                                                isLoading={isLoading}
                                            >
                                                Save
                                            </LoadingButton>
                                        </div>
                                    </Col>
                                </Row>
                            </Form>
                        )}
                    </Formik>
                )}
            </Modal.Body>
        </Modal >
        </>
    );
};

export default AssignStaffToTherapistPop;
